import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be42c410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "catalog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Каталог", -1))
const _hoisted_3 = { class: "catalog-items" }
const _hoisted_4 = { class: "catalog-items" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Показать ещё", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Свернуть", -1))

import HomeCatalogItem from '@/components/Catalogs/HomeCatalogItem.vue'
import IconBase from '@/components/Icons/IconBase.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCatalog',
  props: ['catalog'],
  setup(__props) {

const count = ref(false)
const showMore = () => {
  count.value = true
}
const hideMore = () => {
  count.value = false
}
const props = __props
onMounted(() => {
  Object.keys(props.catalog.results).map((index) => {
    return props.catalog.results[index]
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.catalog?.results, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(HomeCatalogItem, {
          key: `slide_${index}`,
          item: item
        }, null, 8, ["item"])), [
          [_vShow, index < 2]
        ])
      }), 128))
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.catalog?.results, (item, index) => {
            return _withDirectives((_openBlock(), _createBlock(HomeCatalogItem, {
              key: `slide_${index}`,
              item: item
            }, null, 8, ["item"])), [
              [_vShow, index >= 2]
            ])
          }), 128))
        ], 512), [
          [_vShow, count.value]
        ])
      ]),
      _: 1
    }),
    (!count.value)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 0,
          onClick: showMore,
          class: "large rounded more-btn",
          bg: "gradient",
          border: "gradient"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(),
            _createVNode(IconBase, {
              name: "chevron-down",
              "view-box": "0 0 10 4",
              width: 20,
              height: 8
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(BaseButton, {
          key: 1,
          onClick: hideMore,
          class: "large rounded more-btn",
          bg: "gradient",
          border: "gradient"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(),
            _createVNode(IconBase, {
              name: "chevron-down",
              "view-box": "0 0 10 4",
              width: 20,
              height: 8
            })
          ]),
          _: 1
        }))
  ]))
}
}

})